(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$sce','$filter','$timeout','$scope', '$state', 'Principal', 'Search', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','organHierarchy'];

    function HomeController ($sce,$filter,$timeout,$scope, $state, Principal, Search, ParseLinks, AlertService, paginationConstants, pagingParams, organHierarchy) {
        var vm = this;

        vm.isAuthenticated = Principal.isAuthenticated;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.runSearch = runSearch;
        vm.materias = {};
        vm.tipos = {};
        vm.organos = {};
        vm.refreshSlider = refreshSlider;
        vm.translate = translate;
        vm.clearEmissionDate = clearEmissionDate;
        vm.clearPublicationDate = clearPublicationDate;
        vm.disableEmission = disableEmission;
        vm.disablePublication = disablePublication;
        vm.denominacionFormat = denominacionFormat;
        vm.criteria = {
          query: pagingParams.search,
          tipoOrdenamiento: pagingParams.tipo,
          organo: pagingParams.organo,
          materia: capitalize(pagingParams.materia),
          fechaEmisionInicial: pagingParams.emistart,
          fechaEmisionFinal: pagingParams.emiend,
          fechaPublicacionInicial: pagingParams.pubstart,
          fechaPublicacionFinal: pagingParams.pubend,
          abrogado: pagingParams.abrogado
        };
        vm.emissionDates = null;
        vm.publicationDates = null;
        vm.emissionSlider = null;
        vm.publicationSlider = null;
        vm.toggle = toggle;
        vm.toggleWords = toggleWords;
        vm.theight = {'max-height': '500px'};
        vm.orheight = {'max-height': '500px'};
        vm.expandedNodes = [];
        vm.organoHierarchy = [];
        vm.optsTree = optionsTree();
        vm.showSelected = showSelected;
        vm.getExpandedNodes = [];
        vm.state = $state.current;
        vm.fulldates = {};
        loadAll();
        function capitalize(input){
          if(input!=null && input.trim().length>1){
            return input.charAt(0).toUpperCase() + input.slice(1);
          }
          return input;
        }

        function showSelected(sel) {
            vm.selectedNode = sel;
            if(!angular.isUndefined(vm.organos[sel.nombre])){
                vm.organos[sel.nombre] = !vm.organos[sel.nombre]

            }else{
                vm.organos[sel.nombre] = true;
            }
            runSearch();
        };

        function optionsTree(){
            var opts = {
                nodeChildren: "hijos",
                dirSelectable: true,
                injectClasses: {
                    ul: "c-ul",
                    li: "c-li",
                    liSelected: "c-liSelected",
                    iExpanded: "c-iExpanded",
                    iCollapsed: "c-iCollapsed",
                    iLeaf: "c-iLeaf",

                }
            }
            return opts;
        }

        function getValuesorganos(hierarchy){
            var hierarchyarray = [];
            angular.forEach(vm.aggs.organos, function(value, key) {
                var result = $filter('filter')(hierarchy,{nombre:key}, true);
                if(!angular.isUndefined(result) && result.length>0){
                    var node = result[0];
                    node.value = value;

                    hierarchyarray.push(node);
                }

            });

            return hierarchyarray;
        }

        function organFilter(hierarchy){
            var hierarchyarray = getValuesorganos(hierarchy, parent);

            if(hierarchyarray!=null){
                for (var i = 0; i < hierarchyarray.length; i++) {
                    var array = [];
                    hierarchyarray[i].hijos = organFilter(hierarchyarray[i].hijos);

                    for (var j = 0; j < hierarchyarray[i].hijos.length; j++) {
                        var child = hierarchyarray[i].hijos[j];
                        child.padre = hierarchyarray[i];
                    };

                };
            }
            angular.forEach(vm.organos, function(value, key) {
                var expandNode = $filter('filter')(hierarchyarray,{nombre:key}, true);
                if(expandNode.length>0){
                    vm.expandedNodes.push(expandNode[0]);
                }

            });
            return hierarchyarray;
        }

        function getExpandedNodes(){

            for (var i = 0; i < vm.expandedNodes.length; i++) {
                var node = vm.expandedNodes[i];
                while(node.padre!=null){
                    var result = $filter('filter')(vm.expandedNodes,{nombre:node.padre.nombre}, true);
                    if(result.length==0 && !angular.isUndefined(node.padre)){
                        vm.expandedNodes.push(node.padre);
                    }
                    node = node.padre;
                }
            };
        }

        function loadAll () {
            Search.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, vm.criteria, onSuccess, onError);

            Search.aggs({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, vm.criteria, onAggsSuccess, onAggsError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                if(vm.criteria.query!=null && !angular.isUndefined(vm.criteria.query) && vm.criteria.query.trim().length > 0) {
                    result = [];
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.normas = data;
                vm.page = pagingParams.page;
                if(vm.totalItems==0){
                    clearCriteria();
                }else{
                  for (var i = 0; i < vm.normas.length; i++) {
                      vm.normas[i]['height'] = 'true';
                  };
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }

            function onAggsSuccess(data, headers) {
                vm.aggs = data;
                vm.emissionDates = getAllDays(vm.aggs.fechasEmision);
                vm.publicationDates = getAllDays(vm.aggs.fechasPublicacion);
                vm.emissionSlider  = slider(vm.emissionDates, true);
                vm.publicationSlider = slider(vm.publicationDates, false);
                if (!angular.isUndefined(pagingParams.materia) && pagingParams.materia !== null) {
                    vm.materias[pagingParams.materia] = true;
                }

                if (!angular.isUndefined(pagingParams.tipo) && pagingParams.tipo !== null) {
                    vm.tipos[pagingParams.tipo] = true;
                }

                if (!angular.isUndefined(pagingParams.organo) && pagingParams.organo !== null) {
                    vm.organos[pagingParams.organo] = true;
                }
                vm.organoHierarchy= organFilter(organHierarchy);
                getExpandedNodes();
            }
            function onAggsError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.criteria.query,
                tipo: vm.criteria.tipoOrdenamiento,
                organo: vm.criteria.organo,
                materia: vm.criteria.materia,
                emistart: vm.criteria.fechaEmisionInicial,
                emiend: vm.criteria.fechaEmisionFinal,
                pubstart: vm.criteria.fechaPublicacionInicial,
                pubend: vm.criteria.fechaPublicacionFinal
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.criteria.query = searchQuery;
            vm.transition();
        }

        function clearCriteria() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.criteria.query = null;
            vm.criteria.tipoOrdenamiento = null;
            //vm.criteria.materia = null;
            vm.criteria.organo = null;
            vm.criteria.fechaEmisionInicial = null;
            vm.criteria.fechaEmisionFinal = null;
            vm.criteria.fechaPublicacionInicial = null;
            vm.criteria.fechaPublicacionFinal = null;
        }

        function clear() {
            clearCriteria();
            vm.transition();
        }

        function runSearch() {
            vm.criteria.tipoOrdenamiento = null;
            vm.criteria.materia = null;
            vm.criteria.organo = null;
            angular.forEach(vm.tipos, function(value, key){
                if (value) {
                    vm.criteria.tipoOrdenamiento = key;
                }
            });
            angular.forEach(vm.materias, function(value, key){
                if (value) {
                    vm.criteria.materia = key;
                }
            });
            angular.forEach(vm.organos, function(value, key){
                if (value) {
                    vm.criteria.organo = key;
                }
            });

            loadPage();
        }

        function slider(data_slider, emission_flag){

            var slider = {
                minValue:data_slider[0],
                maxValue:data_slider[data_slider.length - 1],
                options: {
                     stepsArray: data_slider,


                     showTicks: true,

                      onStart: function(id) {
                      },
                      onChange: function(id) {

                      },
                      onEnd: function(id) {
                        rangeDates(emission_flag);
                        runSearch();
                      },
                      ticksTooltip: function(v) {
                        return data_slider[v];
                      },
                      getSelectionBarColor: function() {
                          return '#003A70';
                      }
                }

            };
            return slider;
        }

        function refreshSlider() {
            $timeout(function () {
            $scope.$broadcast('rzSliderForceRender');
            });
        };

        function translate(value, sliderId, label) {
            switch (label) {
              case 'model':
                return 'date'
              case 'high':
                return 'date'
              default:
                return '$' + value
            }
        }

        function getAllDays(aggs_dates) {

            var range = [];
            var dates = [];

            for (var k in aggs_dates){
                if (aggs_dates.hasOwnProperty(k)) {
                     dates.push(new Date(Number(k)));
                }
            }

            dates = dates.sort(date_sort_asc);

            for (var i = 0; i < dates.length; i++) {
                    var _date = $filter('date')(dates[i], 'MMMM yyyy');
                    if(range.indexOf(_date) < 0 ){
                        vm.fulldates[_date] = dates[i];
                        range.push(_date);
                    }
            };

            return range;
        };

        function rangeDates(emission_flag){
            var startDate ;
            var endDate;
            if(emission_flag){
                startDate = startMonth(vm.emissionSlider.minValue);
                endDate = endMonth(vm.emissionSlider.maxValue);
                if(startDate instanceof Date){
                    vm.criteria.fechaEmisionInicial = startDate;
                }
                if(endDate instanceof Date){
                    vm.criteria.fechaEmisionFinal = endDate;
                }
            }else{
                startDate = startMonth(vm.publicationSlider.minValue);
                endDate = endMonth(vm.publicationSlider.maxValue);
                if(startDate instanceof Date){
                    vm.criteria.fechaPublicacionInicial = startDate;
                }
                if(endDate instanceof Date){
                    vm.criteria.fechaPublicacionFinal = endDate;
                }
            }
        };

        function endMonth(inputDate){
          var tmp = vm.fulldates[inputDate];
          var fulldate = new Date(tmp);
          var year = fulldate.getFullYear();
          var month = fulldate.getMonth();
          var lastDay = new Date(year, month + 1, 0);
          return lastDay;
        }

        function startMonth(inputDate){
          var tmp = vm.fulldates[inputDate];
          var fulldate = new Date(tmp);
          fulldate.setDate(1);
          return fulldate;
        }

        function date_sort_asc(date1, date2) {
          if (date1 > date2) return 1;
          if (date1 < date2) return -1;
          return 0;
        };

        function date_sort_desc(date1, date2) {
          if (date1 > date2) return -1;
          if (date1 < date2) return 1;
          return 0;
        };

        function clearEmissionDate(){
            vm.criteria.fechaEmisionInicial = null;
            vm.criteria.fechaEmisionFinal = null;
            runSearch();
        };

        function clearPublicationDate(){
            vm.criteria.fechaPublicacionInicial = null;
            vm.criteria.fechaPublicacionFinal = null;
            runSearch();
        }

        function disableEmission(){
            if(vm.criteria.fechaEmisionInicial==null && vm.criteria.fechaEmisionFinal==null){
                return false;
            }
            return true;
        }

        function disablePublication(){
            if(vm.criteria.fechaPublicacionInicial==null && vm.criteria.fechaPublicacionFinal==null){
                return false;
            }
            return true;
        }

        function denominacionFormat(denom_text){
            return $sce.trustAsHtml($filter('scjnHighlight')(denom_text, vm.criteria.query));
        }

        function toggle(ctrl, value) {
            if (ctrl['max-height'] === value) {
                ctrl['max-height'] = 'auto';
            } else {
                ctrl['max-height'] = value;
            }
        }

        function toggleWords(index) {
            vm.normas[index]['height'] = !vm.normas[index]['height'];
        }
    }
})();
